import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LanguageProvider } from '../../../core/language-provider';



export default function DGTH_supplier_order({ entity, data, setData, searchObj, setSearchObj }) {

    const [filterActive, setFilterActive] = useState(null);

    function applyStatusFilter(statusValue) {
        setFilterActive(true);
        const constraints = [
            { fieldName: "status", type: "value", value: statusValue }
        ];
        setSearchObj({
            query: '',
            fields: [],
            constraints: constraints
        });
    }

    function removeFilter() {
        setFilterActive(false);
        setSearchObj({
            query: '',
            fields: [],
            constraints: []
        });
    }


    return (
        <>
            <Button className='m-2' variant='secondary' onClick={() => applyStatusFilter("0_DRAFT")}>{LanguageProvider.getLabel(entity, 'status.options.0_DRAFT')}</Button>
            <Button className='m-2' variant='primary' onClick={() => applyStatusFilter("2_CONFIRMED")}>{LanguageProvider.getLabel(entity, 'status.options.2_CONFIRMED')}</Button>
            <Button className='m-2' variant='info' onClick={() => applyStatusFilter("5_READY")}>{LanguageProvider.getLabel(entity, 'status.options.5_READY')}</Button>
            <Button className='m-2' variant='warning' onClick={() => applyStatusFilter("15_TO_LOAD")}>{LanguageProvider.getLabel(entity, 'status.options.15_TO_LOAD')}</Button>
            <Button className='m-2' variant='success' onClick={() => applyStatusFilter("20_FINISH")}>{LanguageProvider.getLabel(entity, 'status.options.20_FINISH')}</Button>
            {filterActive ? (
                <Button className='m-2' variant='outline-danger' onClick={() => removeFilter()}>
                    <FontAwesomeIcon icon='trash' />
                </Button>
            ) : null}
        </>
    );
};
